import axios from "axios";
import { getToken } from "auth/useToken";

const axiosClient = axios.create({
  // baseURL: "http://localhost:6003",
  baseURL: "https://api-pay.edu-action.uk",
});

// Add request interceptor
axiosClient.interceptors.request.use(
  async (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // a readable message for toasts: the server's own when it sent one
    const data = error?.response?.data;
    error.userMessage =
      data?.message ||
      (typeof data === "string" && data
        ? data
        : error?.response
          ? `The server could not complete the request (error ${error.response.status}). Try again.`
          : "Network error. Check your connection and try again.");
    if (error?.response?.status === 403) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    throw error;
  },
);

export default axiosClient;
